export default "__VITE_ASSET__7v256oIH__"